// extracted by mini-css-extract-plugin
export var background = "fb_4";
export var bottomBackground = "fb_lx";
export var card = "fb_cZ";
export var container = "fb_c";
export var darkToLight = "fb_ly";
export var normal = "fb_hL";
export var small = "fb_b1";
export var topBackground = "fb_lw";